import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "5886d3f9-be4a-4c3e-a176-ee392ae6698b", content: "6 m/s", options: {} },
  { id: "49c71430-d9ee-44ce-9875-89b306419da9", content: "0,6 m/s", options: {} },
  { id: "c7bf22c9-3cd8-4b9e-a2c7-0f58ac4584d7", content: "0,6 m/s<sup>2</sup>", options: {} },

  { id: "858802cc-2219-40b5-adc1-8861ba1454d3", content: "65 m/s<sup>2</sup>", options: {} },
  { id: "ae1961a9-d2e0-4c2b-b952-88af9f9d5be3", content: "4000 m/s<sup>2</sup>", options: {} },
  { id: "1b666949-436e-4ef0-872d-08605428200c", content: "400 m/s<sup>2</sup>", options: {} },

  { id: "cb43dc2a-1cbf-48aa-9ee3-6417e3cda7b8", content: "24 Pa", options: {} },
  { id: "a3482d08-e3e6-476c-95ee-b9076229512b", content: "260 Pa", options: {} },
  { id: "2a14019a-9b3b-49d2-8830-46eed9254f2e", content: "240 m/s", options: {} },
];

export const task: Task = {
  id: "3bb0cade-ada9-420f-9445-a3233dc8d0f7",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: false,
    isMultiple: true,
    columns: 3,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "49c71430-d9ee-44ce-9875-89b306419da9",
    "1b666949-436e-4ef0-872d-08605428200c",
    "a3482d08-e3e6-476c-95ee-b9076229512b",
  ],
};
